import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface ServiceHeroProps {
  badge: string;
  title: string;
  subtitle: string;
  imageUrl: string;
}
export function ServiceHero({
  badge,
  title,
  subtitle,
  imageUrl
}: ServiceHeroProps) {
  return <section className="relative w-full pt-32 pb-24 lg:pt-40 lg:pb-32 flex items-center justify-center overflow-hidden" data-id="element-439">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-440">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover" aria-hidden="true" data-id="element-441" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/40" data-id="element-442" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-443">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md text-white text-xs font-bold px-3 py-1.5 rounded-full mb-6 border border-white/30 shadow-sm" data-id="element-444">
          <ShieldCheckIcon className="w-4 h-4" data-id="element-445" />
          {badge}
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6 drop-shadow-lg" data-id="element-446">
          {title}
        </h1>
        <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed drop-shadow-md font-medium" data-id="element-447">
          {subtitle}
        </p>
      </div>
    </section>;
}